import { render, staticRenderFns } from "./EditProductPopup.vue?vue&type=template&id=36597d7e"
import script from "./EditProductPopup.vue?vue&type=script&lang=js"
export * from "./EditProductPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports